var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInformativo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "23403269-E84B-476D-B440-7D0065096623") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.1-home-aba/carreira-juridica",
    transform: "translate(-24.000000, -801.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-principal",
    transform: "translate(24.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-informativos",
    transform: "translate(0.000000, 569.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    fillOpacity: 0,
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "004-copy-2",
    transform: "translate(2.000000, 2.000000)",
    fill: "#1717CE",
    fillRule: "nonzero",
    stroke: "#1717CE",
    strokeWidth: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "004-copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7124183,21 L6.73202614,21 C5.47111111,21 4.44444444,20.0258897 4.44444444,18.8275862 L4.44444444,5.79310345 C4.44444444,4.5948 5.47111111,3.62068966 6.73202614,3.62068966 L17.7124183,3.62068966 C18.9733333,3.62068966 20,4.5948 20,5.79310345 L20,18.8275862 C20,20.0258897 18.9733333,21 17.7124183,21 Z M6.73202614,4.48965517 C5.97529412,4.48965517 5.35947712,5.07446897 5.35947712,5.79310345 L5.35947712,18.8275862 C5.35947712,19.5462207 5.97529412,20.1310345 6.73202614,20.1310345 L17.7124183,20.1310345 C18.4691503,20.1310345 19.0849673,19.5462207 19.0849673,18.8275862 L19.0849673,5.79310345 C19.0849673,5.07446897 18.4691503,4.48965517 17.7124183,4.48965517 L6.73202614,4.48965517 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.20261438,18.1034483 L2.2875817,18.1034483 C1.02666667,18.1034483 0,17.137069 0,15.9482759 L0,2.15517241 C0,0.96637931 1.02666667,0 2.2875817,0 L13.2679739,0 C14.5288889,0 15.5555556,0.96637931 15.5555556,2.15517241 C15.5555556,2.39310345 15.3505882,2.5862069 15.0980392,2.5862069 C14.8454902,2.5862069 14.6405229,2.39310345 14.6405229,2.15517241 C14.6405229,1.44224138 14.0247059,0.862068966 13.2679739,0.862068966 L2.2875817,0.862068966 C1.53084967,0.862068966 0.91503268,1.44224138 0.91503268,2.15517241 L0.91503268,15.9482759 C0.91503268,16.6612069 1.53084967,17.2413793 2.2875817,17.2413793 L3.20261438,17.2413793 C3.4551634,17.2413793 3.66013072,17.4344828 3.66013072,17.6724138 C3.66013072,17.9103448 3.4551634,18.1034483 3.20261438,18.1034483 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8436214,16.4827586 L8.60082305,16.4827586 C8.3509465,16.4827586 8.14814815,16.3205517 8.14814815,16.1206897 C8.14814815,15.9208276 8.3509465,15.7586207 8.60082305,15.7586207 L15.8436214,15.7586207 C16.0934979,15.7586207 16.2962963,15.9208276 16.2962963,16.1206897 C16.2962963,16.3205517 16.0934979,16.4827586 15.8436214,16.4827586 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8436214,13.2241379 L8.60082305,13.2241379 C8.3509465,13.2241379 8.14814815,13.061931 8.14814815,12.862069 C8.14814815,12.6622069 8.3509465,12.5 8.60082305,12.5 L15.8436214,12.5 C16.0934979,12.5 16.2962963,12.6622069 16.2962963,12.862069 C16.2962963,13.061931 16.0934979,13.2241379 15.8436214,13.2241379 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8436214,9.96551724 L8.60082305,9.96551724 C8.3509465,9.96551724 8.14814815,9.80331034 8.14814815,9.60344828 C8.14814815,9.40358621 8.3509465,9.24137931 8.60082305,9.24137931 L15.8436214,9.24137931 C16.0934979,9.24137931 16.2962963,9.40358621 16.2962963,9.60344828 C16.2962963,9.80331034 16.0934979,9.96551724 15.8436214,9.96551724 Z",
    id: "Path"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInformativo);
export default __webpack_public_path__ + "static/media/ic-informativo.dd0646e5ff1313e29aa2aa2ecc7ecfd8.svg";
export { ForwardRef as ReactComponent };